export class PickupPoint {

	set_address(address) {
		jQuery("input[name='shipping_pickup_point_id']").val(address.pickup_point_id)
		jQuery("input[name='shipping_company_name']").val(address.company_name)
		jQuery("input[name='shipping_address_line_1']").val(address.address_line_1)
		jQuery("input[name='shipping_city']").val(address.city)
		jQuery("input[name='shipping_zip']").val(address.zip)

		jQuery("form#checkout-methods-form").trigger("change")
	}

}